import { InfoProps } from "./types"
import React from "react"
import { Alert } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import { useTheme } from '~/ui/styled'
import useNavigation from "~hooks/useNavigation"
import { TextAccordion, ButtonAccordion } from "~components/accordion"
import { useStores } from "~models"
import styled from '~/ui/styled'
import { Event, EventNames, ContactDeleteData, FLAG_ACK } from "~proto"

const Container = styled.View`
  margin-bottom: 10px;
`

export const Info: React.FC<InfoProps> = ({ userId }) => {
  const theme = useTheme()
  const navigation = useNavigation()
  const { contactStore, eventStore } = useStores()
  const contact = contactStore.byUserId(userId)

  const handleToNoteScreen = () => {
    navigation.push("UpdateContact", { userId })
  }

  const handleAlertRemoveContact = () => {
    Alert.alert("删除联系人", '将联系人"主要名称"删除,将同时删除与该联系人的聊天记录', [
      { text: "取消", style: "cancel" },
      { text: "删除", style: "destructive", onClick: handleSubmitRemoveContact },
    ])
  }
  const handleSubmitRemoveContact = () => {
    const evt = new Event<ContactDeleteData>(EventNames.CONTACT_DELETE, {
      id: contact.id,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
    navigation.pop(2)
  }

  return (
    <>
      <Container>
        {contact && (
          <TextAccordion
            accordionProps={{
              label: contact?.note ? "设置备注" : "描述",
              hasRightIcon: true,
              onClick: handleToNoteScreen,
            }}
            textProps={{
              text: contact.note,
            }}
          />
        )}
      </Container>
      {contact && (
        <ButtonAccordion
          buttonTextProps={{
            color: theme.colors.danger,
            text: "删除",
            onClick: handleAlertRemoveContact,
          }}
          accordionProps={{
            onClick: handleAlertRemoveContact,
          }}
        />
      )}
    </>
  )
}

export default observer(Info)
